"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ExtendableError_1 = __importDefault(require("./ExtendableError"));
/**
 * Thrown when there is an error with the incoming correlation Id
 * @param {string} reason
 */
class CorrelationIdError extends ExtendableError_1.default {
    constructor(reason) {
        super(reason);
        this.reason = reason;
    }
}
exports.default = CorrelationIdError;
